import venturesImage from "../../../img/homeVenturesProgram.svg";
import consultingImage from "../../../img/homeConsultingProgram.svg";
import eventsImage from "../../../img/homeEventsProgram.svg";
import author1 from "../../../img/Aidan O'Brien.png";
import author2 from "../../../img/Leo Cochrane.png";
import author3 from "../../../img/Rider Bishop.jpg";

export const newsletter = [
    {
      name: "VENTURES",
      date: "January 1, 2024",
      description:
        "Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit. Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit.",
      authorHeadshot: author1,
      author: "Aidan O'Brien",
      img: venturesImage,
      readMoreLink: "#"
    },
    {
      name: "ELEVATE",
      date: "January 1, 2024",
      description:
        "Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit. Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit.",
      authorHeadshot: author2,
      author: "Leo Cochrane",
      img: consultingImage,
      navLink: "#"
    },
    {
      name: "EVENTS",
      date: "January 1, 2024",
      description:
        "Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit. Lorem ipsum dolor sit amet consectetur. Adipiscing quis eu mi dolor blandit.",
      authorHeadshot: author3,
      author: "Rider Bishop",
      img: eventsImage,
      navLink: "#"
    },
  ];